import { viewChangeKeyPositionCertificateCoOrdinatorData } from "../../../ViewChangeKeyPositionCertificateCo-ordinator/data/ViewChangeKeyPositionCertificateCoOrdinator.data";
import { viewChangeKeyPositionFormData } from "../ViewChangeKeyPositionForm.data";

export const setAllDropDownField = (apiResponse) => {
    if (!apiResponse || !Array.isArray(apiResponse)) return;

    const groupedDropdowns = apiResponse.reduce((acc, item) => {
        if (!acc[item.dropdownName]) acc[item.dropdownName] = [];
        acc[item.dropdownName].push({ value: item.id, label: item.name });
        return acc;
    }, {});

    const formFields = [...viewChangeKeyPositionFormData.formFields,...viewChangeKeyPositionCertificateCoOrdinatorData.formFields];

    formFields.forEach(field => {
        if (!field?.fieldSetting) return;

        const dropdownNameMap = {
            "membershipTypeId": "Application Type",
            "status": "KeyPosition Status",
        };

        const dropdownName = dropdownNameMap[field.id];
        if (!dropdownName || !groupedDropdowns[dropdownName]) return;

        let options = groupedDropdowns[dropdownName];

        if (field.id === "status") {
            options = options.filter(item => [16, 17, 18].includes(item.value));
        }

        field.fieldSetting = { ...field.fieldSetting, options };
    });
};
